var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.is_loading
        ? _c("div", { staticClass: "text-muted py-3" }, [
            _c("i", { staticClass: "fa fa-spinner fa-spin me-1" }),
            _vm._v(" Memuat data obat...\n    "),
          ])
        : _vm.jenis === "elektronik"
        ? [
            _vm.resep.length
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "row g-3 small mb-3 border-bottom pb-3" },
                      _vm._l(_vm.identitas, function (item) {
                        return _c(
                          "div",
                          { key: item.label, staticClass: "col-md-6 col-lg-4" },
                          [
                            _c("div", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(item.label)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "fw-semibold" }, [
                              _vm._v(_vm._s(item.value || "-")),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.resep, function (r) {
                      return _c("div", { key: r.id, staticClass: "mb-4" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-wrap justify-content-between gap-2 mb-2",
                          },
                          [
                            _c("span", { staticClass: "badge bg-success" }, [
                              _vm._v("Resep " + _vm._s(r.id)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-muted small" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(r.dokter || "-") +
                                  " — " +
                                  _vm._s(
                                    _vm.formatTanggalJam(r.jam || r.tanggal)
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "border rounded p-3 bg-white" },
                          [
                            _vm._l(r.non_racikan, function (obat) {
                              return _c(
                                "div",
                                {
                                  key: obat.kode_obat,
                                  staticClass: "resep-baris",
                                },
                                [
                                  _c("div", { staticClass: "resep-r" }, [
                                    _vm._v("R/"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("div", { staticClass: "fw-semibold" }, [
                                      _vm._v(_vm._s(obat.nama_obat)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-muted small" },
                                      [
                                        _vm._v(
                                          "\n                                S " +
                                            _vm._s(
                                              obat.signa_manual || obat.signa
                                            ) +
                                            "\n                                "
                                        ),
                                        obat.jumlah_hari
                                          ? [
                                              _vm._v(
                                                "\n                                    — " +
                                                  _vm._s(obat.jumlah_hari) +
                                                  " hari\n                                "
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text-nowrap" }, [
                                    _vm._v("No. " + _vm._s(obat.qty)),
                                  ]),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(r.racikan_dokter, function (rd) {
                              return _c(
                                "div",
                                {
                                  key: `rd-${rd.no_racikan}`,
                                  staticClass: "resep-baris",
                                },
                                [
                                  _c("div", { staticClass: "resep-r" }, [
                                    _vm._v("R/"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("div", { staticClass: "fw-semibold" }, [
                                      _vm._v(
                                        "Racikan ke-" + _vm._s(rd.no_racikan)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-muted small" },
                                      [
                                        _vm._v(
                                          "S " +
                                            _vm._s(rd.signa1) +
                                            " dd " +
                                            _vm._s(rd.signa2)
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "mb-0 ps-3 small" },
                                      _vm._l(rd.obat, function (obat) {
                                        return _c(
                                          "li",
                                          { key: obat.kode_obat },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(obat.nama_obat) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text-nowrap" }, [
                                    _vm._v("No. " + _vm._s(rd.qty)),
                                  ]),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(r.racikan, function (rc, index) {
                              return _c(
                                "div",
                                {
                                  key: `rc-${index}`,
                                  staticClass: "resep-baris",
                                },
                                [
                                  _c("div", { staticClass: "resep-r" }, [
                                    _vm._v("R/"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("div", { staticClass: "fw-semibold" }, [
                                      _vm._v(_vm._s(rc.Racikan)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-muted small" },
                                      [_vm._v("S " + _vm._s(rc.Signa || "-"))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text-nowrap" }, [
                                    _vm._v("No. " + _vm._s(rc.Catatan)),
                                  ]),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    }),
                  ],
                  2
                )
              : _c("p", { staticClass: "text-muted mb-0" }, [
                  _c("i", { staticClass: "fa fa-inbox me-1" }),
                  _vm._v(
                    " Belum ada resep elektronik pada registrasi ini.\n        "
                  ),
                ]),
          ]
        : _vm.resep.length
        ? _vm._l(_vm.resep, function (r) {
            return _c("div", { key: r.id, staticClass: "card border mb-3" }, [
              _c(
                "div",
                {
                  staticClass:
                    "card-header bg-light d-flex flex-wrap align-items-center gap-2 py-2",
                },
                [
                  _c("span", { staticClass: "badge bg-success" }, [
                    _vm._v("Resep ke-" + _vm._s(r.resep_ke)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fw-semibold small" }, [
                    _vm._v(_vm._s(_vm.waktuResep(r))),
                  ]),
                  _vm._v(" "),
                  r.poli
                    ? _c("span", { staticClass: "text-muted small" }, [
                        _vm._v(_vm._s(r.poli)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "text-muted small ms-auto" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(r.dokter || "-") +
                          "\n                    "
                      ),
                      r.regno
                        ? [_vm._v("— No. Reg " + _vm._s(r.regno))]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-responsive" }, [
                _c(
                  "table",
                  { staticClass: "table table-sm align-middle mb-0" },
                  [
                    _vm._m(0, true),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(r.obat, function (obat) {
                        return _c(
                          "tr",
                          {
                            key: `${r.id}-${obat.kode_obat}-${obat.no_racikan}`,
                          },
                          [
                            _c("td", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(obat.kode_obat)),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(obat.nama_obat) +
                                  "\n                                "
                              ),
                              obat.jenis === 4
                                ? _c(
                                    "span",
                                    { staticClass: "badge bg-secondary ms-1" },
                                    [
                                      _vm._v(
                                        "\n                                    Racikan ke-" +
                                          _vm._s(obat.no_racikan) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(obat.qty) + " " + _vm._s(obat.satuan)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(obat.signa_manual || obat.signa)),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "small text-muted" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    obat.keterangan_pakai ||
                                      obat.cara_minum ||
                                      ""
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              (r.racikan || []).length
                ? _c("div", { staticClass: "table-responsive border-top" }, [
                    _c(
                      "table",
                      { staticClass: "table table-sm align-middle mb-0" },
                      [
                        _vm._m(1, true),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(r.racikan, function (rc, index) {
                            return _c("tr", { key: `${r.id}-rc-${index}` }, [
                              _c("td", [_vm._v(_vm._s(rc.Racikan))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(rc.Signa))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(rc.Catatan))]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          })
        : _c("p", { staticClass: "text-muted mb-0" }, [
            _c("i", { staticClass: "fa fa-inbox me-1" }),
            _vm._v(
              " Tidak ada " + _vm._s(_vm.label) + " untuk pasien ini.\n    "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "110px" } }, [_vm._v("Kode")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nama Obat")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "80px" } }, [_vm._v("Qty")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "170px" } }, [_vm._v("Signa")]),
        _vm._v(" "),
        _c("th", [_vm._v("Keterangan")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", [_vm._v("Racikan")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "170px" } }, [_vm._v("Signa")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "80px" } }, [_vm._v("Qty")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }